import { render, staticRenderFns } from "./orderAmmount.vue?vue&type=template&id=f52d53ca&scoped=true&"
import script from "./orderAmmount.vue?vue&type=script&lang=js&"
export * from "./orderAmmount.vue?vue&type=script&lang=js&"
import style0 from "./orderAmmount.vue?vue&type=style&index=0&id=f52d53ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52d53ca",
  null
  
)

export default component.exports